import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { toggleHelp } from '@app/actions/helpActions';

import DefaultButton from '@components/buttons/default-btn/DefaultButton';

const HelpToggler = ({ isHelpActive, toggleHelp, className = '', ...props }) => {
  return (
    <DefaultButton
      id="qau-btn-toggle-help"
      locKey="qau-title-help"
      onClick={toggleHelp}
      className={classnames(className, { active: isHelpActive })}
      aria-expanded={isHelpActive}
      {...props}
    />
  );
};

const mapStateToProps = ({ help }) => ({
  isHelpActive: !!help.activated,
});

const mapDispatchToProps = {
  toggleHelp,
};

HelpToggler.propTypes = {
  isHelpActive: PropTypes.bool.isRequired,
  toggleHelp: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpToggler);
